import { Outlet } from "react-router-dom";
import Header from "./fragments/Header";

export default function LandROut() {
	return (
		<>
			<Header />

			<Outlet />
		</>
	);
}
